module.exports = __webpack_public_path__ + "static/media/logo_pt@2x.672ca0b2.png";